import './style.scss';

import React, { Fragment } from 'react';
import Promise from 'bluebird';
import { connect } from 'react-redux';
import { setPhoneNumber, showLogin } from 'components/login/actions';
import { setAddress } from 'components/address/actions';
import { validPhone } from 'shared/models/address';
import { bookBartender } from 'shared/models/api';
import {
  getAvailability,
  calculateTotal,
  selectPromo,
  removePromo,
  setOrderId
} from './actions';
import { showPromo, loadPromos } from 'components/promo/actions';
import { loadCards } from 'components/payment/actions';
import moment from 'moment';
import _ from 'lodash';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import Address from './address';
import Select from 'react-select';
import Spinner from 'react-spinkit';
import MaskedInput from 'react-text-mask';
import AuthModal from '../login/modal';
import Confirmation from './confirmation';
import Payment from './payment';
import Promo from '../promo';
import RadioSlider from '../ui/radioSlider';
import SauceyLogo from 'images/saucey-logo-white.svg';

class Bartender extends React.Component {
  constructor(props) {
    super(props);

    this.leadTime = 48;
    this.rate = props.rate;
    this.tipMask = createNumberMask({
      allowDecimal: true
    });

    this.bartenderOptions = [1, 2, 3, 4, 5];
    this.guestToBartenderMap = {
      '< 30': 1,
      '30-75': 1,
      '75-100': 2,
      '100-150': 2,
      '150+': 3
    };
    this.guestOptions = _.keys(this.guestToBartenderMap);

    const { fullName, phone, email } = this._getUserAttrs(props.login.user);

    this.state = {
      date: null,
      dateError: false,
      startTime: null,
      endTime: null,
      guests: this.guestOptions[0],
      bartenders: this.bartenderOptions[0],
      fullName,
      phone,
      email,
      notes: '',
      tipRate: props.baseTipRate,
      tip: '',
      submitting: false,
      submitError: null,
      success: false
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.updateAddress = this.updateAddress.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.handleGuestsChange = this.handleGuestsChange.bind(this);
    this.handleBartendersChange = this.handleBartendersChange.bind(this);
    this.updateFullName = this.updateFullName.bind(this);
    this.updatePhone = this.updatePhone.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
    this.showPromoModal = this.showPromoModal.bind(this);
    this.selectPromo = this.selectPromo.bind(this);
    this.removePromo = this.removePromo.bind(this);
    this.handleTipChange = this.handleTipChange.bind(this);
    this.requestBartender = this.requestBartender.bind(this);
    this.signup = this.signup.bind(this);
    this.login = this.login.bind(this);
  }

  componentWillMount() {
    this.minDate = moment()
      .add(this.leadTime + 1, 'hours')
      .startOf('hour');
    this.minDateValue = this.minDate.format('YYYY-MM-DD');
  }

  componentWillReceiveProps(nextProps) {
    const prevCurrentUser = (this.props.login && this.props.login.user) || {};
    const nextCurrentUser = nextProps.login.user;
    if (!nextCurrentUser) return;

    if (prevCurrentUser.objectId !== nextCurrentUser.objectId) {
      const { fullName, email, phone } = this._getUserAttrs(nextCurrentUser);
      if (fullName && fullName !== this.state.fullName)
        this.setState({ fullName });
      if (phone && phone !== this.state.phone) this.setState({ phone });
      if (email && email !== this.state.email) this.setState({ email });
      this.props.setOrderId();
      this.props.loadCards();
      this.props.loadPromos({ all: true });
    }

    const nextSubtotal =
      nextProps.booking && nextProps.booking.subtotal_pre_discount;
    const prevSubtotal =
      this.props.booking && this.props.booking.subtotal_pre_discount;
    if (nextSubtotal !== prevSubtotal) this.updateSuggestedTip(nextSubtotal);
  }

  componentDidUpdate(prevProps, prevState) {
    this._fetchNewTotal(prevProps, prevState);
    if (this.state.success) window.scrollTo(0, 0);
  }

  _fetchNewTotal(prevProps, prevState) {
    const currentUser = this.props.login.user;
    if (!currentUser) return;
    const idFor = user => user && user.objectId;

    const address = this.props.address;
    if (!address.lat || !address.lng) return;

    const { bartenders, startTime, endTime } = this.state;
    const valueOf = time => time && time.value.valueOf();
    const codeFor = props => (props.promo ? props.promo.code : null);

    const start = valueOf(startTime);
    const end = valueOf(endTime);
    const code = codeFor(this.props);

    const paramsHaveChanged =
      address.lat !== prevProps.address.lat ||
      address.lng !== prevProps.address.lng ||
      bartenders !== prevState.bartenders ||
      start !== valueOf(prevState.startTime) ||
      end !== valueOf(prevState.endTime) ||
      code !== codeFor(prevProps) ||
      idFor(currentUser) !== idFor(prevProps.login.user);

    if (address && bartenders && start && end && paramsHaveChanged) {
      this.props.calculateTotal({ address, bartenders, start, end, code });
    }
  }

  _getUserAttrs(user) {
    const firstName = (user && user.firstname) || '';
    const lastName = (user && user.lastname) || '';
    const fullName = firstName && lastName ? `${firstName} ${lastName}` : '';
    const phone = (user && user.mobile) || '';
    const email = (user && user.email) || '';
    return { fullName, phone, email };
  }

  signup() {
    this.props.showLogin('signup');
  }

  login() {
    this.props.showLogin('login');
  }

  handleDateChange(event) {
    let date = moment(event.target.value).hours(0);
    if (date < moment(this.minDate).hours(0)) {
      this.setState({ dateError: true });
      return;
    }

    date = moment.max(this.minDate, date);

    this.setState({
      date,
      dateError: false,
      startTime: null,
      endTime: null,
      submitError: null
    });
  }

  updateAddress(address) {
    this.props.setAddress(address, {
      page: 'Book a Bartender',
      source: 'Bartender Form'
    });
    this.props.getAvailability(address);
  }

  getStartTimeOptions(date) {
    /* First hour should be 9 AM, or 24 full hours from now. Last should be midnight */
    const firstHour = moment.max(moment(date), moment(date).hours(9));
    const lastHour = moment(firstHour).hours(24);
    return this._hourOptions(firstHour, lastHour);
  }

  getEndTimeOptions(date, start) {
    /* First hour should be noon, or 3 hours after selected start time. Last should be soonest future 3 AM. */
    const firstHour = moment.max(
      moment(start).add(3, 'hours'),
      moment(date).hours(12)
    );
    const lastHour = moment(date)
      .hours(24)
      .add(3, 'hours');
    return this._hourOptions(firstHour, lastHour);
  }

  _hourOptions(firstHour, lastHour) {
    let options = [];
    let hour = firstHour;

    while (hour.isSameOrBefore(lastHour)) {
      options.push({
        value: moment(hour),
        label: hour.format('hh:mm A')
      });
      hour.add(1, 'hours');
    }

    return options;
  }

  handleStartTimeChange(startTime) {
    let endTime = this.state.endTime;
    if (endTime && endTime.value.diff(startTime.value, 'hours') < 3) {
      endTime = null;
    }
    this.setState({
      startTime,
      endTime,
      submitError: null
    });
  }

  handleEndTimeChange(endTime) {
    this.setState({ endTime, submitError: null });
  }

  handleGuestsChange(guests) {
    this.setState({ guests });

    if (!this._bartendersTouched) {
      const bartenders = this.guestToBartenderMap[guests];
      this.setState({ bartenders });
    }
  }

  handleBartendersChange(bartenders) {
    this._bartendersTouched = true;
    this.setState({ bartenders });
  }

  updateFullName(event) {
    this.setState({ fullName: event.target.value });
  }

  updatePhone(event) {
    this.setState({ phone: event.target.value });
  }

  updateEmail(event) {
    this.setState({ email: event.target.value });
  }

  updateNotes(event) {
    this.setState({ notes: event.target.value });
  }

  showPromoModal() {
    this.props.showPromo(true);
  }

  selectPromo(promo) {
    this.props.selectPromo(promo);
  }

  removePromo() {
    this.props.removePromo();
  }

  _promoDisplayValue(promo) {
    if (!promo) return '';
    switch (promo.value_type) {
      case '%':
        return `${100 * promo.value}%`;
      case 'hour':
        return promo.value === 1
          ? `${promo.value} hour free`
          : `${promo.value} hours free`;
      default:
        return `$${promo.value}`;
    }
  }

  handleTipChange(event) {
    const subtotal =
      this.props.booking && this.props.booking.subtotal_pre_discount;
    if (!_.isNumber(subtotal)) return;

    let tip = event.target.value.replace(/[$,]/g, '');
    if (!tip) {
      this.setState({ tip: '', tipRate: null });
      return;
    }

    const tipRate = (Number(tip) / subtotal * 100).toFixed(2);
    this.setState({ tip, tipRate });
  }

  updateSuggestedTip(subtotal) {
    if (!_.isNumber(subtotal)) return;
    const tipRate = this.props.baseTipRate / 100;
    const suggestedTip = (subtotal * tipRate).toFixed(2);
    this.setState({ tip: suggestedTip });
  }

  requestBartender(e) {
    e.preventDefault();
    this.setState({ submitError: null });

    this._ensureDateAndTime()
      .then(() => this._ensureAddress())
      .then(() => this._ensureUser())
      .then(() => this._ensurePhoneNumber())
      .then(() => this._ensurePayment())
      .then(() => this._submitForm())
      .catch(err => this.setState({ submitError: err }));
  }

  _ensureDateAndTime() {
    return new Promise((resolve, reject) => {
      if (
        this.state.dateError ||
        !this.state.date ||
        !this.state.startTime ||
        !this.state.endTime
      ) {
        reject('A valid booking date and time are required');
      } else {
        resolve();
      }
    });
  }

  _ensureAddress() {
    return new Promise((resolve, reject) => {
      if (!this.props.address) {
        reject('Address is required');
      } else {
        resolve();
      }
    });
  }

  _ensureUser() {
    return new Promise((resolve, reject) => {
      if (!this.props.login.user) {
        reject('You must have a Saucey account to request a bartender');
      } else {
        resolve();
      }
    });
  }

  _ensurePhoneNumber() {
    this.validPhone = validPhone(this.state.phone);
    return new Promise((resolve, reject) => {
      if (!this.validPhone) {
        reject('A valid phone number is required');
      } else {
        resolve();
      }
    });
  }

  _ensurePayment() {
    return new Promise((resolve, reject) => {
      if (!this.props.cardId) {
        reject('A credit card is required');
      } else {
        resolve();
      }
    });
  }

  _submitForm() {
    const params = {
      address: this.props.address,
      cardId: this.props.cardId,
      start: this.state.startTime.value.valueOf(),
      end: this.state.endTime.value.valueOf(),
      guests: this.state.guests,
      bartenders: this.state.bartenders,
      notes: this.state.notes,
      contact: {
        name: this.state.fullName,
        phone: this.state.phone,
        email: this.state.email
      }
    };

    if (this.state.tip) params.tip = Number(this.state.tip);
    if (this.props.promo && this.props.promo.code) {
      params.code = this.props.promo.code;
    }

    this.setState({ submitting: true });
    return bookBartender(params)
      .then(() => this.setState({ success: true }))
      .catch(res =>
        this.setState({ submitError: res.body && res.body.message })
      )
      .finally(() => this.setState({ submitting: false }));
  }

  render() {
    const { date, startTime, endTime } = this.state;
    this.startTimeOptions = this.getStartTimeOptions(date);
    this.endTimeOptions = this.getEndTimeOptions(
      date,
      startTime && startTime.value
    );

    this.displayDate = moment.isMoment(date) ? date.format('MM/DD/YY') : '';

    this.displayTimeRange =
      startTime &&
      endTime &&
      `${startTime.value.format('h:mmA')} – ${endTime.value.format('h:mmA')}`;

    const prepLineItem =
      _.find(
        this.props.lineItems,
        lineItem => lineItem.label === 'bartender prep'
      ) || {};
    this.bartenderPrep = prepLineItem.value;

    const totalHoursLineItem =
      _.find(
        this.props.lineItems,
        lineItem => lineItem.label === 'total hours'
      ) || {};
    this.totalHours = totalHoursLineItem.value;

    this.preDiscountSubtotal =
      this.props.booking && this.props.booking.subtotal_pre_discount;
    this.displaySubtotal =
      this.preDiscountSubtotal && `$${this.preDiscountSubtotal}`;
    const postDiscountSubtotal =
      this.props.booking && this.props.booking.subtotal;

    const promo = this.props.promo;
    if (this.preDiscountSubtotal && postDiscountSubtotal && promo) {
      this.promoDisplayValue = this._promoDisplayValue(promo);
      this.promoType = promo.value_type;
      this.promoDollarValue = this.preDiscountSubtotal - postDiscountSubtotal;
    } else {
      this.promoDisplayValue = null;
      this.promoType = null;
      this.promoDollarValue = null;
    }

    this.total = this.props.booking && this.props.booking.total;
    if (this.total && this.state.tip)
      this.total = Number(this.total) + Number(this.state.tip);
    if (this.total && this.total !== Math.round(this.total))
      this.total = this.total.toFixed(2);
    this.displayTotal = this.total && `$${this.total}`;

    return (
      <div className="bartender">
        <div className="bartender-header">
          <a href="/">
            <img src={SauceyLogo} className="bartender-header__logo" />
          </a>
          {this.state.success ? (
            <h1 className="bartender-header__title">Bartender Booked</h1>
          ) : (
            <Fragment>
              <h1 className="bartender-header__title">Book a Bartender</h1>
              <small className="bartender-header__subtitle">
                Must book {this.leadTime} hours in advance. Rate is ${this.rate}/hr.
              </small>
            </Fragment>
          )}
        </div>

        {this.state.success ? (
          <Confirmation
            address={this.props.address}
            start={this.state.startTime.value}
            end={this.state.endTime.value}
            guests={this.state.guests}
          />
        ) : (
          <div className="bartender-main">
            <form onSubmit={this.requestBartender}>
              <fieldset className="bartender-section">
                <legend className="bartender-section__heading">
                  Where is this debauchery?
                </legend>
                {!!this.props.address.address &&
                  !this.props.availabilityLoading &&
                  !this.props.available && (
                    <span className="error">Not available at this address</span>
                  )}
                <Address
                  className="bartender__form-control"
                  setAddress={this.updateAddress}
                  disabled={this.props.availabilityLoading}
                />
              </fieldset>

              <hr className="light" />

              <fieldset className="bartender-section">
                <legend className="bartender-section__heading">
                  <span>When is it? </span>
                  <small>(Min of 3 hours)</small>
                </legend>
                {!!this.props.prepText && (
                  <div className="bartender-section__subheading text-small text-light text-emphasized">
                    {this.props.prepText}
                  </div>
                )}
                <label htmlFor="bartender-date" className="bartender__label">
                  Select Date:
                </label>
                {this.state.dateError && (
                  <span className="error">Not available on this date</span>
                )}
                <input
                  type="date"
                  id="bartender-date"
                  className="bartender__form-control"
                  placeholder="mm/dd/yyyy"
                  min={this.minDateValue}
                  onBlur={this.handleDateChange}
                />
                <div className="row">
                  <div className="col-xs-6">
                    <Select
                      instanceId="bartender-from"
                      placeholder="From"
                      name="startTime"
                      className="bartender__form-control bartender__form-control--select"
                      searchable={false}
                      clearable={false}
                      disabled={!this.state.date}
                      value={this.state.startTime}
                      options={this.startTimeOptions}
                      onChange={this.handleStartTimeChange}
                    />
                  </div>
                  <div className="col-xs-6">
                    <Select
                      instanceId="bartender-to"
                      placeholder="To"
                      name="endTime"
                      className="bartender__form-control bartender__form-control--select"
                      searchable={false}
                      clearable={false}
                      disabled={!this.state.date}
                      value={this.state.endTime}
                      options={this.endTimeOptions}
                      onChange={this.handleEndTimeChange}
                    />
                  </div>
                </div>
              </fieldset>

              <hr className="light" />

              <fieldset className="bartender-section">
                <legend className="bartender-section__heading">
                  How many guests?
                </legend>
                <RadioSlider
                  name="guests"
                  options={this.guestOptions}
                  selectedOption={this.state.guests}
                  onChange={this.handleGuestsChange}
                />
              </fieldset>

              <fieldset className="bartender-section">
                <legend className="bartender-section__heading">
                  How many bartenders?
                </legend>
                <RadioSlider
                  name="bartenders"
                  options={this.bartenderOptions}
                  selectedOption={this.state.bartenders}
                  onChange={this.handleBartendersChange}
                />
              </fieldset>

              <div className="bartender-submit">
                {this.state.submitting ? (
                  <Spinner spinnerName="three-bounce" noFadeIn />
                ) : (
                  <button type="submit" className="button btn-primary">
                    Request Bartender
                  </button>
                )}
              </div>
            </form>

            <hr className="light" />

            {!this.props.login.user && (
              <section className="bartender-section">
                <div className="bartender-section__heading">
                  Create an account
                </div>
                <button
                  className="btn-secondary button button-wide"
                  onClick={this.signup}
                >
                  Sign Up
                </button>
                <button
                  className="btn-secondary button button-wide"
                  onClick={this.login}
                >
                  Login
                </button>
              </section>
            )}

            <AuthModal />

            {!this.props.login.user && <hr className="light" />}

            {!!this.props.login.user && (
              <section className="bartender-section">
                <h4 className="bartender-section__heading">
                  Booking Information
                </h4>
                <input
                  placeholder="Full Name"
                  className="bartender__form-control"
                  type="text"
                  defaultValue={this.state.fullName}
                  onChange={this.updateFullName}
                />
                <input
                  placeholder="Email"
                  className="bartender__form-control"
                  type="email"
                  defaultValue={this.state.email}
                  onChange={this.updateEmail}
                />
                <MaskedInput
                  mask={[
                    /\d/,
                    /\d/,
                    /\d/,
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    ' ',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/
                  ]}
                  id="address-phone"
                  className="bartender__form-control"
                  type="tel"
                  placeholder="Phone Number"
                  value={this.state.phone}
                  onChange={this.updatePhone}
                />
                <textarea
                  placeholder="NOTES (Optional)"
                  className="bartender__form-control bartender__form-control--notes"
                  value={this.state.notes}
                  onChange={this.updateNotes}
                />
                <div className="bartender__payment">
                  <Payment />
                </div>
              </section>
            )}

            {!!this.props.login.user && <hr className="light" />}

            <section className="bartender-section bartender__order-summary">
              <h4 className="bartender-section__heading">Summary</h4>
              <div className="row bartender__line-item">
                <div className="col-xs-6 col-sm-4 text-left">Booking Date</div>
                <div className="col-xs-6 col-sm-8 text-right bartender__line-item-value">
                  <span style={{ marginRight: '0.5em' }}>
                    {this.displayDate}
                  </span>
                  <span>{this.displayTimeRange}</span>
                </div>
              </div>
              <div className="row bartender__line-item">
                <div className="col-xs-6 col-sm-4 text-left">
                  Bartender Prep
                </div>
                <div className="col-xs-6 col-sm-8 text-right bartender__line-item-value">
                  {this.bartenderPrep}
                </div>
              </div>
              <div className="row bartender__line-item">
                <div className="col-xs-6 col-sm-4 text-left">Total Hours</div>
                <div className="col-xs-6 col-sm-8 text-right bartender__line-item-value">
                  {this.totalHours}
                </div>
              </div>
              <div className="row bartender__line-item">
                <div className="col-xs-6 col-sm-4 text-left">Guests</div>
                <div className="col-xs-6 col-sm-8 text-right bartender__line-item-value">
                  {this.state.guests}
                </div>
              </div>
              <div className="row bartender__line-item">
                <div className="col-xs-6 col-sm-4 text-left">Bartenders</div>
                <div className="col-xs-6 col-sm-8 text-right bartender__line-item-value">
                  {this.state.bartenders}
                </div>
              </div>
            </section>

            <hr className="light" />

            {this.props.totalLoading && (
              <Spinner className="three-spinner" noFadeIn />
            )}

            <div className="bartender-section">
              <div className="row bartender__line-item">
                <div className="col-xs-6 text-left">Subtotal</div>
                <div className="col-xs-6 text-right bartender__line-item-value">
                  {!this.props.totalLoading && this.displaySubtotal}
                </div>
              </div>

              <div className="row bartender__line-item">
                <div className="col-xs-6 text-left">
                  {!this.promoType || this.promoType === '$'
                    ? 'Promo Code'
                    : this.promoType === 'hour'
                      ? this.promoDisplayValue
                      : this.promoType === '%'
                        ? `Discount (${this.promoDisplayValue})`
                        : ''}
                </div>

                {!this.props.totalLoading && (
                  <div className="col-xs-6 text-right">
                    {!!this.preDiscountSubtotal &&
                      !this.promoType && (
                        <span onClick={this.showPromoModal} className="link">
                          Add promo code
                        </span>
                      )}

                    {!!this.promoType && (
                      <span
                        onClick={this.showPromoModal}
                        className="bartender__line-item-value bartender__line-item-value--promo"
                      >
                        {this.promoType === '$'
                          ? `-${this.promoDisplayValue}`
                          : this.promoType === 'hour' || this.promoType === '%'
                            ? `-$${this.promoDollarValue}`
                            : ''}
                      </span>
                    )}
                  </div>
                )}
              </div>

              <Promo
                selectPromo={this.selectPromo}
                selectedPromo={this.props.promo}
                removePromo={this.removePromo}
                orderId={this.props.orderId}
              />

              <div className="row middle-xs bartender__line-item">
                <div className="col-xs-7 text-left">Tip</div>
                <div className="col-xs-5 bartender__line-item-value">
                  <MaskedInput
                    className="form-control text-right"
                    type="tel"
                    mask={this.tipMask}
                    value={this.state.tip}
                    onChange={this.handleTipChange}
                  />
                </div>
                <div className="col-xs-12 text-right text-light text-small text-emphasized">
                  {!!this.props.booking &&
                    Number(this.props.booking.subtotal_pre_discount) &&
                    this.state.tip === '' && (
                      <span>
                        Suggested tip: ${Number(
                          this.props.booking.subtotal_pre_discount
                        ) *
                          this.props.baseTipRate /
                          100}
                      </span>
                    )}
                  {!!this.state.tip && <span>({this.state.tipRate}%)</span>}
                </div>
              </div>

              <div className="row bartender__line-item">
                <div className="col-xs-6 text-left">Total</div>
                <div className="col-xs-6 text-right bartender__line-item-value">
                  {!this.props.totalLoading && this.displayTotal}
                </div>
              </div>
            </div>

            <div className="bartender-section">
              <div className="row">
                <div className="col-xs-12">
                  <div className="text-light text-small text-emphasized">
                    * Bartender does not bring alcohol or mixers. A concierge
                    will contact you shortly to coordinate details for your
                    booking. Cheers.
                  </div>
                </div>
              </div>
            </div>

            {!!this.state.submitError && (
              <div className="row">
                <div className="col-xs-12">
                  <div className="error">{this.state.submitError}</div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.bartender,
    address: state.address,
    login: state.login,
    payment: state.payment
  };
}

export default connect(mapStateToProps, {
  setAddress,
  setPhoneNumber,
  showLogin,
  getAvailability,
  calculateTotal,
  loadCards,
  loadPromos,
  showPromo,
  removePromo,
  selectPromo,
  setOrderId
})(Bartender);



// WEBPACK FOOTER //
// ./shared/components/bartender/index.js